import { Screen, Hotspot } from "@/components/site/Screen";
import { navFor, PAGE_HOTSPOTS, PAGE_LABELS } from "@/components/site/siteData";

export const NavSpots = ({ page, go }) =>
  navFor(page).map((n, i) => (
    <Hotspot key={`nav-${i}`} {...n} label={n.label || `Open ${PAGE_LABELS[n.to]}`}
      onClick={() => go(n.to)} testId={`${page}-nav-${n.label ? "book-now" : n.to}-${i}`} />
  ));

export const PageSpots = ({ page, go }) =>
  (PAGE_HOTSPOTS[page] || []).map((h, i) => (
    <Hotspot key={`spot-${i}`} {...h} onClick={() => go(h.to)} testId={`${page}-cta-${i}`} />
  ));

export const ArtPage = ({ page, go }) => (
  <section aria-label={PAGE_LABELS[page]}>
    <Screen page={page}>
      <NavSpots page={page} go={go} />
      <PageSpots page={page} go={go} />
    </Screen>
  </section>
);
